<ng-container *ngIf="practice">
  <ng-container *ngIf="createInProgress">
    <p-progressSpinner
      [style]="{
                width: '40px',
                height: '40px',
                margin: '40px auto',
                display: 'block',
            }"
      styleClass="custom-spinner"
      strokeWidth="4"
    ></p-progressSpinner>
  </ng-container>
  <ng-container *ngIf="!createInProgress">
    <ng-container *ngIf="step === 0">
      <div class="subtitle">{{'forms.components.new_request.search_client' | translate }}</div>
      <client-selector
        [noModal]="true"
        (clientSelected)="selectClient($event)"
      ></client-selector>
      <ng-container>
        <div class="subtitle">{{'forms.components.new_request.enter_phone' | translate}}</div>
        <div class="phone-input">
          <input
            pInputText
            (paste)="validatePhoneInput()"
            (keydown)="validateKeyPress($event)"
            (keyup)="
              $event.key == 'Enter' ? usePhoneNumber() : validatePhoneInput()
            "
            maxlength="30"
            type="text"
            [(ngModel)]="phoneNumber"
            placeholder="{{'forms.components.new_request.phone_number' | translate}}"
          />
          <button
            pButton
            label="{{'forms.components.new_request.next' | translate}}"
            [disabled]="!phoneNumberIsValid"
            (click)="usePhoneNumber()"
          ></button>
        </div>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="step === 1">
      <div class="subtitle">{{'forms.components.new_request.select_contact' | translate}}</div>
      <ng-container *ngIf="selectedClient">
        <div class="contact-selector-wrap">
          <div class="client-details">
            <div class="name">
              {{ selectedClient.title }}
              {{ selectedClient.firstName }}
              {{ selectedClient.lastName }} ({{
                selectedClient.pmsDisplayId ?? selectedClient.pmsId
              }})
            </div>
            <div class="address">
              {{ (selectedClient.hNameNo && selectedClient.hNameNo.trim()) ? selectedClient.hNameNo + "," : "" }}
              {{ (selectedClient.address1 && selectedClient.address1.trim()) ? selectedClient.address1 + "," : "" }}
              {{ (selectedClient.address2 && selectedClient.address2.trim()) ? selectedClient.address2 + "," : "" }}
              {{ (selectedClient.address3 && selectedClient.address3.trim()) ? selectedClient.address3 + "," : "" }}
              {{ (selectedClient.postcode && selectedClient.postcode.trim()) ? selectedClient.postcode + "," : "" }}
              {{ (selectedClient.state && selectedClient.state.trim()) ? selectedClient.state : "" }}
            </div>
          </div>
          <ng-container
            *ngFor="let contact of this.selectedClient.mobileContacts"
          >
            <div class="contact-selector">
              <div class="label">{{ contact.name }}: {{ contact.value }}</div>
              <button
                pButton
                label="{{'ui.client_list_item.select' | translate}}"
                class="p-button-sm p-button-ghost"
                (click)="selectContact(contact)"
              ></button>
            </div>
          </ng-container>
        </div>
      </ng-container>
      <div class="next-step">
        <div class="back" (click)="goBackTo(0)">
          <img src="assets/images/icons/back.svg" alt="" />
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="step === 2">
      <div class="subtitle">
        {{'forms.components.new_request.select_channel' | translate}}
      </div>

      <div class="channel-dropdown-wrap">
        <p-dropdown
          [options]="channels"
          [(ngModel)]="currentChannelOption"
          optionLabel="name"
          optionDisabled="inactive"
          class="channel-dropdown"
        >
          <ng-template pTemplate="selectedItem">
            <div
              class="channel-item channel-item-selected {{
                currentChannelOption.className
              }}"
              *ngIf="currentChannelOption"
            >
              <img
                [src]="'assets/images/icons/' + currentChannelOption.icon"
                class="channel-icon"
              />
              <div>{{ currentChannelOption.name }}</div>
            </div>
          </ng-template>
          <ng-template let-channel pTemplate="item">
            <div class="channel-item {{ channel.className }}">
              <img
                [src]="'assets/images/icons/' + channel.icon"
                class="channel-icon"
              />
              <div>{{ channel.name }}</div>
            </div>
          </ng-template>
        </p-dropdown>
      </div>

      <div class="next-step">
        <div class="back" (click)="goBackTo(1)">
          <img src="assets/images/icons/back.svg" alt="" />
        </div>
        <p-button
          (click)="goToFormStep()"
          label="{{'forms.components.new_request.next' | translate}}"
          styleClass="p-button-primary"
        ></p-button>
      </div>
    </ng-container>

    <ng-container *ngIf="step === 3">
      <div class="alert-message" *ngIf="showNoClientWarning">
        <p>{{'forms.components.new_request.please_be_aware_that_you_are_creating' | translate}}</p>
        <ul>
          <li>{{'forms.components.new_request.automatically_prefilled' | translate}}</li>
          <li>{{'forms.components.new_request.once_complete' | translate}}</li>
        </ul>
        <div class="next-step">
          <div class="back" (click)="goBackTo(2)">
            <img src="assets/images/icons/back.svg" alt="" />
          </div>
          <p-button
            (click)="hideNoClientWarning()"
            label="{{'forms.components.new_request.next' | translate}}"
            styleClass="p-button-primary"
          ></p-button>
        </div>
      </div>
      <ng-container *ngIf="!showNoClientWarning">
        <div class="subtitle">{{'forms.components.new_request.select_form' | translate}}</div>
        <div class="form-selector">
          <form-selector
            (formSelected)="handleFormSelected($event)"
            [isRegistered]="isRegistered"
          ></form-selector>
        </div>

        <div class="next-step">
          <div class="back" (click)="goBackTo(2)">
            <img src="assets/images/icons/back.svg" alt="" />
          </div>
        </div>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="step === 4">
      <ng-container *ngIf="formLoading">
        <p-progressSpinner
          [style]="{
                        width: '40px',
                        height: '40px',
                        margin: '40px auto',
                        display: 'block',
                    }"
          styleClass="custom-spinner"
          strokeWidth="4"
        ></p-progressSpinner>
      </ng-container>
      <ng-container *ngIf="!formLoading">
        <div class="subtitle">{{'forms.components.new_request.select_patient' | translate}}</div>
        <div class="patient-select">
          <ng-container *ngIf="patients.length > 0 || !patientsLoading">
            <patient-selector
              [disabled]="false"
              [loading]="patientsLoading"
              [patients]="patients"
              (patientSelected)="selectPatient($event)"
              (morePatients)="handleMorePatients()"
            ></patient-selector>
          </ng-container>
          <ng-container *ngIf="patientsLoading">
            <div class="loading">
              <p-progressSpinner
                [style]="{
                                    width: '40px',
                                    height: '40px',
                                    margin: '40px auto',
                                    display: 'block',
                                }"
                styleClass="custom-spinner"
                strokeWidth="4"
              ></p-progressSpinner>
            </div>
          </ng-container>
        </div>
        <div class="next-step">
          <div class="back" (click)="goBackTo(3)">
            <img src="assets/images/icons/back.svg" alt="" />
          </div>
        </div>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="step === 5">
      <ng-container *ngIf="formLoading">
        <p-progressSpinner
          [style]="{
                        width: '40px',
                        height: '40px',
                        margin: '40px auto',
                        display: 'block',
                    }"
          styleClass="custom-spinner"
          strokeWidth="4"
        ></p-progressSpinner>
      </ng-container>
      <ng-container *ngIf="!formLoading">
        <div class="subtitle">{{'forms.components.new_request.preview' | translate}}</div>
        <ng-container *ngIf="fieldsToPrefill.length === 0">
          <div class="no-prefill">{{'forms.components.new_request.no_prefill' | translate}}</div>
        </ng-container>
        <ng-container *ngIf="fieldsToPrefill.length > 0">
          <div class="prefills">
            <ng-container *ngFor="let field of fieldsToPrefill">
              <div class="prefill-field">
                <div class="label">{{ field.label }}</div>
                <div class="input">
                  <ng-container *ngIf="selectedClient">
                    <input
                      *ngIf="field.prefill && !field.customizeContent"
                      #prefillInputs
                      pInputText
                      type="text"
                      [name]="field.id.toString()"
                      [ngModel]="getFieldValue(field.id) || (field.prefillWith | getFieldPrefillValue : selectedClient : selectedPatient : practice)"
                      (ngModelChange)="updateFieldValue(field.id, $event)"
                    />
                    <div class="customizeContent-input">
                      <ng-container *ngIf="field.customizeContent">
                        <ng-container *ngIf="field.type === 'TEXTAREA'">
                          <textarea
                            #prefillInputs
                            pInputTextarea
                            [name]="field.id.toString()"
                            [ngModel]="getFieldValue(field.id) || field.default || ''"
                            (ngModelChange)="updateFieldValue(field.id, $event)"
                          ></textarea>
                        </ng-container>
                        <ng-container *ngIf="field.type != 'TEXTAREA'">
                          <input
                            #prefillInputs
                            pInputText
                            type="text"
                            [name]="field.id.toString()"
                            [ngModel]="getFieldValue(field.id) || field.default || ''"
                            (ngModelChange)="updateFieldValue(field.id, $event)"
                          />
                        </ng-container>
                      </ng-container>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="!selectedClient && !field.customizeContent">
                    <input
                      #prefillInputs
                      pInputText
                      type="text"
                      [name]="field.id.toString()"
                      [ngModel]="getFieldValue(field.id)"
                      (ngModelChange)="updateFieldValue(field.id, $event)"
                    />
                  </ng-container>
                </div>
              </div>
            </ng-container>
          </div>
        </ng-container>
        <div class="next-step">
          <div class="back" (click)="goBackTo(4)">
            <img src="assets/images/icons/back.svg" alt="" />
          </div>
          <ng-container *ngIf="sites.length > 1 || selectedForm?.takePayment">
            <p-button
              (click)="
                selectedForm?.takePayment ? goToPaymentStep() : goToSiteStep()
              "
              label="{{'forms.components.new_request.next' | translate}}"
              styleClass="p-button-primary"
            ></p-button>
          </ng-container>
          <ng-container *ngIf="sites.length < 2 && !selectedForm?.takePayment">
            <p-button
              (click)="sendForm()"
              label="{{'forms.components.new_request.send_form' | translate}}"
              styleClass="p-button-primary"
            ></p-button>
          </ng-container>
        </div>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="step === 6">
      <ng-container *ngIf="formLoading">
        <p-progressSpinner
          [style]="{
                        width: '40px',
                        height: '40px',
                        margin: '40px auto',
                        display: 'block',
                    }"
          styleClass="custom-spinner"
          strokeWidth="4"
        ></p-progressSpinner>
      </ng-container>
      <ng-container *ngIf="!formLoading && selectedForm?.takePayment">
        <div class="subtitle">{{'forms.components.new_request.customize_payment_information' | translate}}</div>
        <div class="site-select input-holder full-width">
          <ng-container *ngIf="errors.length > 0">
            <div class="errors">
              <ng-container *ngFor="let error of errors">
                <div class="form-error">
                  {{ error.key | translate : error.params }}
                </div>
              </ng-container>
            </div>
          </ng-container>

          <div class="payment-field">
            <div class="payment-input">
              <ng-container *ngIf="selectedForm">
                <div class="label">
                  <label>{{'forms.components.new_request.payment_amount' | translate}}</label>
                  <ng-container>
                    <input
                      #prefillInputs
                      pInputText
                      type="number"
                      step="0.01"
                      min="0"
                      [name]="'payment_' + selectedForm.id + '_amount'"
                      [ngModel]="getFieldValue('payment_' + selectedForm.id + '_amount') || selectedForm.paymentAmount"
                      (ngModelChange)="updatePaymentAmount($event)"
                      (blur)="validatePaymentFields()"
                    />
                  </ng-container>
                </div>
                <div class="label">
                  <label>{{'forms.components.new_request.payment_description' | translate}}</label>
                  <ng-container>
                    <input
                      #prefillInputs
                      pInputText
                      type="text"
                      [name]="'payment_' + selectedForm.id + '_description'"
                      [ngModel]="getFieldValue('payment_' + selectedForm.id + '_description') || selectedForm.paymentDescription"
                      (ngModelChange)="updatePaymentDescription($event)"
                      [maxLength]="maxPaymentDescriptionLength"
                      (blur)="validatePaymentFields()"
                    />
                  </ng-container>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
        <div class="next-step">
          <div class="back" (click)="goBackTo(5)">
            <img src="assets/images/icons/back.svg" alt="" />
          </div>
          <ng-container *ngIf="sites.length > 1">
            <p-button
              (click)="
                goToSiteStep()
              "
              label="{{'forms.components.new_request.next' | translate}}"
              styleClass="p-button-primary"
              [disabled]="!isPaymentFormValid()"
            ></p-button>
          </ng-container>
          <ng-container *ngIf="sites.length < 2">
            <p-button
              (click)="sendForm()"
              label="{{'forms.components.new_request.send_form' | translate}}"
              styleClass="p-button-primary"
              [disabled]="!isPaymentFormValid()"
            ></p-button>
          </ng-container>
        </div>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="step === 7">
      <div class="subtitle">{{'forms.components.new_request.select_site' | translate}}</div>
      <div class="site-select input-holder full-width">
        <select class="primary" [(ngModel)]="selectedSiteId" (ngModelChange)="onSiteIdChange($event)">
          <option value="0">{{'forms.components.new_request.please_select' | translate}}</option>
          <ng-container *ngFor="let site of sites">
            <option value="{{ site.id }}">{{ site.name }}</option>
          </ng-container>
        </select>
        <ng-container *ngIf="siteError">
          <div class="error">{{ siteError }}</div>
        </ng-container>
      </div>
      <div class="next-step">
        <div class="back" (click)="goBackTo(5)">
          <img src="assets/images/icons/back.svg" alt="" />
        </div>
        <p-button
          (click)="sendForm()"
          label="{{'forms.components.new_request.send_form' | translate}}"
          styleClass="p-button-primary"
        ></p-button>
      </div>
    </ng-container>
  </ng-container>
</ng-container>
